import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonFunctions } from '@shared/common-functions';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { DriverService } from '@core/services/driver.service';
import { CONTACT_ERR_MSG, CustomValidator, EMAIL_VALIDATION_PATTERN, MULTILINGUAL_NAME_VALIDATION_PATTERN } from 'src/app/shared';
import { passwordValidator } from 'src/app/shared/services/custom-validatior.abstract';
import { ToastService } from 'src/app/shared/services/toast.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { ConfigService } from '@core/services/config.service';
@Component({
  selector: 'app-dispatcher-signup',
  templateUrl: './dispatcher-signup.component.html',
  styleUrls: ['./dispatcher-signup.component.scss']
})
export class DispatcherSignupComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  signupForm: FormGroup;
  countryISO: CountryISO = CountryISO.UnitedStates;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  searchCountryField = SearchCountryField;
  separateDialCode = false;
  phoneNumberFormat = PhoneNumberFormat;
  resendOtp:boolean = false;
  otpEmail: any;
  countDown: string = '1:00';
  showButton: boolean = false;
  showOtpComponent = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  otp: string;
  isSignUp: boolean = true;
  loginInput: { email: string, mobile: string };
  requiredLastNameAsterisk: boolean = false;

  constructor(private readonly fb: FormBuilder,
    private readonly service: DriverService,
    private readonly toastService: ToastService,
    private readonly router: Router,
    private readonly encryptStorage: EncryptionStorageService,
    private readonly configService: ConfigService
  ) { }

ngOnInit(): void {
    const { validators, required } = CommonFunctions.getLastNameValidators('groupOperator', this.configService);    
    this.requiredLastNameAsterisk = required;
    this.signupForm = this.fb.group({
      groupName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
      dotNumber: ['', [Validators.maxLength(12), Validators.minLength(6)]],
      firstName: ['', [Validators.required, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(50), CommonFunctions.noLeadingSpacesValidator()]],
      lastName: ['', [...validators,Validators.minLength(3), Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.maxLength(50), CommonFunctions.noLeadingSpacesValidator()]],
      email: ['', [Validators.required,Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
      phoneNumber: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15),passwordValidator]],
      confirmPassword: ['', [Validators.required,passwordValidator]],
    });
    window.scrollTo(0, 0);
    const isEmailVerified = this.encryptStorage.getItem('isEmailVerified');
    if (isEmailVerified == 'false') {
      this.loginInput = JSON.parse(this.encryptStorage.getItem('loginInput') || '{}');
      this.showOtpComponent = true
      this.isSignUp = false
      this.otpEmail = this.encryptStorage.getItem('email');
      this.sendOtp()
    }
  }

  get groupName() {
    return this.signupForm.get('groupName');
  }

  get dotNumber() {
    return this.signupForm.get('dotNumber');
  }

  get firstName() {
    return this.signupForm.get('firstName');
  }

  get lastName() {
    return this.signupForm.get('lastName');
  }

  get email() {
    return this.signupForm.get('email');
  }

  get phoneNumber() {
    return this.signupForm.get('phoneNumber');
  }

  get password() {
    return this.signupForm.get('password');
  }

  get confirmPassword() {
    return this.signupForm.get('confirmPassword');
  }

  passwordMatchValidator(formGroup: FormGroup): Validators {
    const password = formGroup.get('password');
    const confirmPassword = formGroup.get('confirmPassword');
    return password && confirmPassword && password.value === confirmPassword.value ? null : { mustMatch: true };
  }

  onPasswordKeyDown(event: KeyboardEvent, controlName: string): void {
    const maxLength = 15;
    const control = this.signupForm.get(controlName);
    const currentValueLength = control?.value.length ?? 0;
  
    if (currentValueLength >= maxLength && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }

  onSubmit(formData): void {
    if (this.signupForm.valid) {
      if (!formData.email && !formData.phoneNumber) {
        this.toastService.showToastMessage('error', 'Error', CONTACT_ERR_MSG);
        return;
      }
      if (formData.password === formData.confirmPassword) {
        const signupRequest = {
          email: this.signupForm.value.email,
          firstName: this.signupForm.value.firstName,
          lastName: this.signupForm.value.lastName,
          password: this.signupForm.value.password,
          groupName: this.signupForm.value.groupName,
          dotNumber: this.signupForm.value.dotNumber,
          mobileNumber: this.signupForm.value.phoneNumber?.number || '',
          countryCode: this.signupForm.value.phoneNumber?.dialCode || '',
          iso: this.signupForm.value.phoneNumber?.countryCode || '',
          confirmPassword: this.signupForm.value.confirmPassword
        }
        
        this.otpEmail = formData.email;
        this.service.createGroupUser(signupRequest)
          .pipe(autoUnsubWith(this.destroyRef))
          .subscribe({
            next: (_res) => {
              this.toastService.showToastMessage('success', 'Success', 'Group Operator created successfully!');
              this.router.navigate(['login']);
            },
            error: (error) => {
              this.toastService.showToastMessage('error', 'Error', error.error.message);
            }
          });
      } else {
        
        this.toastService.showToastMessage('error', 'Error', 'Confirm Password should match the Password');
      }

    } else {
      CustomValidator.markFormGroupTouched(this.signupForm);
    }
  }

  sendOtp() {
    this.startCountDown();
    const req: any = {
      verificationFor: 1,
      email: this.otpEmail || this.loginInput?.email,
      mobileNumber: this.signupForm.value.phoneNumber?.number || this.loginInput?.mobile,
      requestCount: 0
    }
    this.service.sendOtpForVerification(req).pipe(
      autoUnsubWith(this.destroyRef)
    ).subscribe({
      next: (_res) => {
        if (_res) {

if(!this.resendOtp){
            this.toastService.showToastMessage('success', 'Success', _res.message);
          }else{
            this.toastService.showToastMessage('success', 'Success', 'Passcode resent successfully!');
          }
        }
      },
      error: (er) => {
        
        this.showButton = true;
        this.toastService.showToastMessage('error', 'Error', er.error.message);
      }

    });
  }

  onOtpChange(otp) {
    this.otp = otp;
  }

  startCountDown() {
    let countDownDate = new Date();
    countDownDate.setMinutes(countDownDate.getMinutes() + 1);
    let countDownInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countDownDate.getTime() - now;
      let minutes = Math.floor(distance / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.countDown = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      if (distance <= 0) {
        clearInterval(countDownInterval);
        this.countDown = '0:00';
        this.showButton = true;
      }
    }, 1000);
  }

  verifyEmailByOTP() {
    
    const req: any = {
      email: this.otpEmail || this.loginInput?.email,
      mobileNumber: this.signupForm.value?.phoneNumber?.number || this.loginInput?.mobile,
      otp: this.otp
    }

    this.service.verifyEmailByOTP(req).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_res) => {
        if (_res.message) {
          
          this.toastService.showToastMessage('success', 'Success', 'Account verified successful!');
          this.router.navigate(['login']);
        }
             }, error: (error) => {
        if (error) {
          
          if(error.error.message ==='Please send Passcode'){
            this.toastService.showToastMessage('error', 'Error', 'Please Enter Passcode');
          }else{
            this.toastService.showToastMessage('error', 'Error', error.error.message);
          }
        }
      }
    })
  }

  onClickSendOtp(event) {
    event.preventDefault();
    this.sendOtp();
    this.resendOtp = true;
  }

  redirect() {
    this.router.navigate(["/login"]);
  }
    onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
}
